<template>
  <div :class="[{ stripe: stripe, hoverFlat: hoverFlat }, `vs-table-${color}`]" class="vs-component vs-con-table">
    <!-- header -->
    <header class="header-table vs-table--header flex flex-wrap gap-4 mb-4 items-end justify-start">
      <slot name="header"></slot>

      <vs-input v-if="search" v-model="searchx" :class="searchInputClass" icon="icon-search" icon-pack="feather" />
    </header>
    <div class="con-tablex vs-table--content space-y-4">
      <div :class="{ 'is-scrollable': isScrollable }" :style="styleConTbody" class="vs-con-tbody vs-table--tbody">
        <table ref="table" class="vs-table vs-table--tbody-table">
          <thead ref="thead" class="vs-table--thead">
            <tr>
              <th v-if="hasCheckColumn" class="td-check">
                <span v-if="multiple" class="con-td-check">
                  <vs-checkbox
                    :key="isCheckedLine ? 'remove' : 'check'"
                    :icon="isCheckedLine ? 'remove' : 'check'"
                    :checked="isCheckedMultiple"
                    size="small"
                    @change="changeCheckedMultiple" />
                </span>
              </th>
              <slot name="thead"></slot>
            </tr>
          </thead>
          <slot :data="datax"></slot>
        </table>
      </div>

      <div v-if="isNoData" class="not-data-table vs-table--not-data">
        {{ noDataText }}
      </div>

      <div v-if="pagination" class="con-pagination-table vs-table--pagination">
        <ui-pagination
          v-model="currentx"
          :total="searchx && !sst ? getTotalPagesSearch : getTotalPages"
          :description-items="descriptionItems"
          :max-items="maxItemsx"
          :size-array="!sst ? queriedResults.length : total"
          :description="description"
          :description-title="descriptionTitle"
          :description-connector="descriptionConnector"
          :description-body="descriptionBody"
          @changeMaxItems="changeMaxItems">
          <template v-if="$scopedSlots.pageSizeSelector" v-slot:pageSizeSelector>
            <slot name="pageSizeSelector"></slot>
          </template>
        </ui-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UITable",
  props: {
    // Array when `multiple` is set, otherwise the selected row.
    value: {
      default: null,
    },
    color: {
      default: "primary",
      type: String,
    },
    noDataText: {
      default: "No data Available",
      type: String,
    },
    stripe: {
      default: false,
      type: Boolean,
    },
    hoverFlat: {
      default: false,
      type: Boolean,
    },
    maxHeight: {
      default: "auto",
      type: String,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    data: {
      default: () => [],
    },
    notSpacer: {
      default: false,
      type: Boolean,
    },
    search: {
      default: false,
      type: Boolean,
    },
    // Replaces the width utilities rather than adding to them: the default pair
    // is what makes the box 16rem from sm up, so an override has to drop them.
    searchInputClass: {
      default: "sm:w-64 w-full",
      type: [String, Array, Object],
    },
    maxItems: {
      default: 5,
      type: [Number, String],
    },
    pagination: {
      default: false,
      type: Boolean,
    },
    description: {
      default: false,
      type: Boolean,
    },
    descriptionItems: {
      default: () => [],
      type: Array,
    },
    descriptionTitle: {
      type: String,
    },
    descriptionConnector: {
      type: String,
    },
    descriptionBody: {
      type: String,
    },
    currentPage: {
      default: 1,
      type: [Number, String],
    },
    sst: {
      default: false,
      type: Boolean,
    },
    sortKey: {
      type: String,
      default: null,
    },
    sortType: {
      type: String,
      default: null,
    },
    total: {
      type: Number,
      default: 0,
    },
    onlyClickCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    datax: [],
    searchx: null,
    currentx: 1,
    maxItemsx: 5,
    // Misspelled deliberately: vuesax's own vs-tr does
    // `this.$parent.hasExpadableData = true`, and seven views nest vs-tr inside
    // ui-table. Renaming this silently breaks their expand column.
    hasExpadableData: false,
    currentSortKey: null,
    currentSortType: null,
  }),
  computed: {
    isScrollable() {
      return this.maxHeight !== "auto"
    },
    getTotalPages() {
      const totalLength = this.sst && this.total ? this.total : this.data?.length ?? 0
      return Math.ceil(totalLength / this.maxItemsx)
    },
    getTotalPagesSearch() {
      return Math.ceil(this.queriedResults.length / this.maxItemsx)
    },
    queriedResults() {
      let queriedResults = this.data || []
      if (this.searchx && this.search) {
        let dataBase = this.data || []
        queriedResults = dataBase.filter((tr) => {
          let values = this.getValues(tr).toString().toLowerCase()
          return values.indexOf(this.searchx.toLowerCase()) != -1
        })
      }
      return queriedResults
    },
    isNoData() {
      if (!this.datax) {
        return true
      }

      return Array.isArray(this.datax) ? this.datax.length === 0 : Object.keys(this.datax).length === 0
    },
    isCheckedLine() {
      return (this.data?.length ?? 0) !== (this.value?.length ?? 0)
    },
    isCheckedMultiple() {
      return (this.value?.length ?? 0) > 0
    },
    styleConTbody() {
      return {
        maxHeight: this.maxHeight,
        overflow: this.maxHeight != "auto" ? "auto" : null,
      }
    },
    hasCheckColumn() {
      return this.multiple || this.hasExpadableData
    },
  },
  watch: {
    currentPage() {
      this.currentx = this.currentPage
    },
    currentx() {
      if (this.sst) {
        this.$emit("change-page", this.currentx)
      } else {
        this.loadData()
      }
    },
    maxItems(val) {
      this.maxItemsx = val
      this.loadData()
    },
    maxItemsx() {
      this.loadData()
    },
    data() {
      this.loadData()
    },
    sortKey(value) {
      this.currentSortKey = value
    },
    sortType(value) {
      this.currentSortType = value
    },
    searchx() {
      if (this.sst) {
        this.$emit("search", this.searchx)
      } else {
        this.loadData()
        this.currentx = 1
      }
    },
  },
  created() {
    // Seed before children are created: UITh reads these in its own mounted(),
    // which runs before the parent's.
    this.currentSortKey = this.sortKey
    this.currentSortType = this.sortType
  },
  mounted() {
    this.maxItemsx = this.maxItems
    this.loadData()
  },
  methods: {
    // Number of columns the consumer declared. UITr uses this for the colspan of
    // its expand row. A method, not a computed: $slots is not reactive, so a
    // computed would cache the first count forever.
    getThs() {
      return (this.$slots.thead || []).filter((item) => item.tag).length
    },
    loadData() {
      let max = Math.ceil(this.currentx * this.maxItemsx)
      let min = this.sst ? 0 : max - this.maxItemsx

      if (!this.searchx || this.sst) {
        this.datax = this.pagination ? this.getItems(min, max) : this.sortItems(this.data) || []
      } else {
        this.datax = this.getItemsSearch(min, max) || []
      }
    },
    getItems(min, max) {
      let dataBase = this.sortItems(this.data)

      let items = []
      dataBase.forEach((item, index) => {
        if (index >= min && index < max) {
          items.push(item)
        }
      })
      return items
    },
    sortItems(data) {
      // Server-side tables are already ordered by the backend; re-sorting the
      // current page here would contradict its ordering and its page boundaries.
      if (this.sst) {
        return [...(data || [])]
      }

      const { currentSortKey, currentSortType } = this

      function compare(a, b) {
        if (a[currentSortKey] < b[currentSortKey]) return currentSortType == "desc" ? 1 : -1
        if (a[currentSortKey] > b[currentSortKey]) return currentSortType == "desc" ? -1 : 1
        return 0
      }
      return currentSortType !== null ? [...(data || [])].sort(compare) : [...(data || [])]
    },
    getItemsSearch(min, max) {
      const search = this.normalize(this.searchx)

      return this.sortItems(this.data)
        .filter((tr) => {
          return this.normalize(this.getValues(tr).toString()).indexOf(search) != -1
        })
        .filter((_, index) => {
          return index >= min && index < max
        })
    },
    sort(key, sortType) {
      this.currentSortKey = key
      this.currentSortType = sortType
      if (this.sst) {
        this.$emit("sort", key, sortType)
        return
      }
      this.loadData()
    },
    normalize(string) {
      return string
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    },
    getValues: function getValues(obj) {
      function flattenDeep(val) {
        return Object.values(val || []).reduce(
          (acc, val) => (typeof val === "object" ? acc.concat(flattenDeep(val)) : acc.concat(val)),
          []
        )
      }

      return flattenDeep(obj).filter(function (item) {
        return typeof item === "string" || typeof item === "number"
      })
    },
    changeCheckedMultiple() {
      const remaining = (this.data?.length ?? 0) - (this.value?.length ?? 0)

      this.$emit("input", remaining === 0 ? [] : this.data)
    },
    handleCheckbox(tr) {
      if (this.multiple && this.onlyClickCheckbox) {
        let val = this.value.slice(0)
        if (val.includes(tr)) {
          val.splice(val.indexOf(tr), 1)
        } else {
          val.push(tr)
        }

        this.$emit("input", val)
        this.$emit("selected", tr)
      }
    },
    clicktr(tr, isTr) {
      if (this.multiple && isTr && !this.onlyClickCheckbox) {
        let val = this.value.slice(0)
        if (val.includes(tr)) {
          val.splice(val.indexOf(tr), 1)
        } else {
          val.push(tr)
        }

        this.$emit("input", val)
        this.$emit("selected", tr)
      } else if (isTr && !this.onlyClickCheckbox) {
        this.$emit("input", tr)
        this.$emit("selected", tr)
      }
    },
    dblclicktr(tr, isTr) {
      if (isTr) {
        this.$emit("dblSelection", tr)
      }
    },
    syncCurrentPage() {
      this.currentx = this.currentPage
    },
    syncSort() {
      this.currentSortKey = this.sortKey
      this.currentSortType = this.sortType
    },
    changeMaxItems(index) {
      this.maxItemsx = this.descriptionItems[index]
      // Server-side tables page on the owner's copy of the size, not ours.
      this.$emit("change-max-items", this.maxItemsx)
    },
  },
}
</script>

<style>
/* Auto table-layout hands every unsized column a share of the free space once
   the table stretches, and this one only ever holds a 16px chevron or checkbox.
   Sits above vuesax's own min-content (5px padding either side of the icon), so
   the browser honours it. */
.vs-table--tbody-table .td-check {
  width: 2.5rem;
}

/* The <thead> lives inside the scroll container, so it scrolls out of view once
   max-height is set. vuesax tried to solve this by mirroring the header into a
   second table and syncing column widths through a <colgroup> (changeTdsWidth,
   getThs, headerWidth) — but the markup for it was never shipped. position:
   sticky does the same job without measuring anything. */
.vs-con-tbody.is-scrollable .vs-table--thead tr {
  background-color: #f8f8f8;
}

.vs-con-tbody.is-scrollable .vs-table--thead th {
  position: sticky;
  top: 0;
  z-index: 200;
  /* follows the row, so the dark theme's thead background still wins */
  background-color: inherit;
}
</style>
